import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'contrast', 'Contrast', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M12 17a5 5 0 0 0 0 -10v10"}]]);